import React, {useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import moment from "moment-timezone";
import Datetime from "react-datetime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Container, Form, Button, InputGroup, Pagination } from '@themesberg/react-bootstrap';
import {DoctorsContainer, DoctorsH1, ServicesWrapper, ServicesCard, ServicesIcon, ServicesH2, ServicesP} from "../components/services/ServicesElements";
import Icon4 from "../images/calendar.svg";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { BASE_URL } from '../constants';
const RequestDoctorScreen = () => {
    const [date, setDate] = useState(null);
    const [specialty, setSpecialty] = useState('');
      const [specialities, setSpecialities] = useState([]);
      const [doctors, setDoctors] = useState([]);
      const [loading, setLoading] = useState(false);
      const [error, setError] = useState(null);
      const [success, setSuccess] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const doctorsPerPage = 3; // Number of doctors to display per page
  
    // Calculate the range of doctors to display on the current page
    const indexOfLastDoctor = currentPage * doctorsPerPage;
  const indexOfFirstDoctor = indexOfLastDoctor - doctorsPerPage;
  const currentDoctors = doctors.slice(indexOfFirstDoctor, indexOfLastDoctor);

  // Calculate page numbers
  const pageNumbers = Math.ceil(doctors.length / doctorsPerPage);
  
    // Create an array of page numbers for pagination
  

    useEffect(() => {
        const fetchSpecialities = async () => {
            try {
                const response = await fetch(`${BASE_URL}/doctors/specialties`);
                const data = await response.json();
                setSpecialities(data);
            } catch (error) {
                console.error('Error fetching specialities:', error);
            }
        };

        fetchSpecialities();
    }, []);
    useEffect(() => {
      const fetchDoctors = async () => {
          try {
              const response = await fetch(`${BASE_URL}/doctors`);
              const data = await response.json();
              setDoctors(data);
          } catch (error) {
              console.error('Error fetching specialities:', error);
          }
      };

      fetchDoctors();
  }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);
   
    const token = localStorage.getItem('token');
   
    try {
      const formattedDate = date ? moment(date).format('YYYY-MM-DD') : '';
        const response = await fetch(`${BASE_URL}/refugees/book`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ specialty, date: formattedDate })
        });

        const data = await response.json();
        setLoading(false);

        if (!response.ok) {
            setError(data.msg || 'Date not available');
            return;
        }

        setSuccess(data.msg|| 'Booking success');
    } catch (err) {
        setLoading(false);
        setError('Server Error');
    }
};

  return (
    <Layout>
  <Container fluid className="d-flex justify-content-center align-items-center">
                <Row className="justify-content-center align-items-center w-100">
                    <Col md={8} lg={6} xl={5} className="my-3">
                        <div className="p-4">
                        <Form onSubmit={handleSubmit}>
            <Form.Group controlId="speciality">
                <Form.Label>Select Speciality:</Form.Label>
                <Form.Control
                    as="select"
                    value={specialty}
                    onChange={(e) => setSpecialty(e.target.value)}
                >
                    <option value="">Select Speciality</option>
                    {specialities.map((speciality, index) => (
                        <option key={index} value={speciality}>
                            {speciality}
                        </option>
                    ))}
                </Form.Control>
            </Form.Group>

            <Form.Group controlId="date" className="mt-3">
        <Form.Label>Select Date:</Form.Label>
        <Datetime
          dateFormat="MM/DD/YYYY"
          timeFormat={false}
          value={date ? moment(date).format("MM/DD/YYYY") : ""}
          onChange={(newDate) => setDate(newDate)}
          renderInput={(props, openCalendar) => (
            <InputGroup>
              <InputGroup.Text>
                <FontAwesomeIcon icon={faCalendarAlt} />
              </InputGroup.Text>
              <Form.Control
                required
                type="text"
                placeholder="mm/dd/yyyy"
                onFocus={openCalendar}
                value={date ? moment(date).format("MM/DD/YYYY") : ""}
                onChange={() => {}}
              />
            </InputGroup>
          )}
        />
      </Form.Group>


            <Button
                variant="dark"
                className="mt-4"
                type="submit"
                block
                disabled={loading}
            >
                {loading ? 'Booking...' : 'Book Appointment'}
            </Button>

            {error && <p className="text-danger mt-3">{error}</p>}
            {success && <p className="text-success mt-3">{success}</p>}
        </Form>
                        </div>
                    </Col>
                    <Col md={4} lg={3} xl={2} className="d-flex justify-content-center align-items-center my-3">
                        <ServicesIcon src={Icon4} />
                    </Col>
                </Row>
            </Container>
            <DoctorsContainer id="services">
      <DoctorsH1>Our Doctors</DoctorsH1>
      <ServicesWrapper>
        {currentDoctors.map((doctor, index) => (
          <ServicesCard key={index}>
            <ServicesIcon src={doctor.profilePhoto} alt={`${doctor.name}'s profile`} />
            <ServicesH2>
              <Link to={`/doctor/${doctor._id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                {doctor.name}
              </Link>
            </ServicesH2>
            <ServicesP>{doctor.specialty}</ServicesP>
          </ServicesCard>
        ))}
      </ServicesWrapper>

      <Pagination>
        {Array.from({ length: pageNumbers }, (_, index) => (
          <Pagination.Item
            key={index + 1}
            active={index + 1 === currentPage}
            onClick={() => setCurrentPage(index + 1)}
            className="me-1"
          >
            {index + 1}
          </Pagination.Item>
        ))}
      </Pagination>
    </DoctorsContainer>
</Layout>
  );
};

export default RequestDoctorScreen;
